import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/avatar.jpg'


const _withScopeId = n => (_pushScopeId("data-v-c6f3425a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entity" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("march1993")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Posts")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sharing")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("About")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "title-line",
      to: { name: 'Home' }
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_link, { class: "site-title" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_menu, {
      class: "the-menu",
      mode: "horizontal",
      router: true,
      "default-active": _ctx.defaultActiveMenu,
      ellipsis: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/posts" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/sharing" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/about" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}